export default __webpack_public_path__ + "static/media/dataGraph.ece33f59.png";